<template>
  <div class="container">
    <div class="container py-4">
      <div class="alert alert-info" role="alert">
        {{ loading ? "Accesso in corso..." : "Redirect..." }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, inject, onMounted } from "vue";
import {useRoute, useRouter} from "vue-router";
import useAuthStore from "@/stores/auth.store.js";
import axios from "@/services/axios.setup.js"
import { errorToast } from "@/services/toast.service";

const authStore = useAuthStore();
const router = useRouter();
const route = useRoute();
//route.query.token variabile get token
const tryAsync = inject('tryAsync');

const loading = ref(true);



onMounted(async () => {
  // Il backend, dopo il login su Azure, rimanda qui con un codice monouso
  // da scambiare con i dati di login (token compresi)
  const code = route.query.code;

  if (!code) {
    errorToast("Callback SSO non valido: parametri mancanti.");
    await router.replace("/login");
    return;
  }

  try {
    const { data } = await tryAsync(
      axios.post("/auth/azure/token", { code }),
      "Errore nel richiedere il token di login",
      () => loading.value = false
    );

    if (data.result === 'success') {
      authStore.setUser(data);
      await router.replace("/");
    } else {
      errorToast(data.message);
      await router.replace("/login");
    }
  } catch {
    await router.replace("/login");
  }
});

</script>

<style></style>
